export default __webpack_public_path__ + "static/media/logo_full_light.5c556893.svg";